/* eslint-disable */

export default {
  errorMessage:
    "An error occurred while attempting to retrieve data from the API.",
};


export const text = {
  dofe: "dofe"
};

export const ALLOWED_IMAGE_FILE_TYPE = ["jpg", "jpeg", "png"];

export const IME_BEST_TERM = 66;

